module.exports = __webpack_public_path__ + "img/telephone-inbound.e9208a95.svg";